// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rX4pAv5sWHFNjp {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: var(--ds-border-radius-200, 8px);
  outline: 0;
  background-color: var(--ds-surface-overlay, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
}
.MqQlviJ8LO60NB {
  display: grid;
  position: relative;
  grid-template-columns: 32px 1fr 32px;
  align-items: center;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 4px 8px;
  text-align: center;
}
.MqQlviJ8LO60NB.ehJjRqKTyUZYML {
  display: flex;
  position: static;
  box-sizing: border-box;
  grid: none;
  align-items: center;
  min-height: 40px;
  max-height: 49px;
  margin: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-100, 8px);
  padding: var(--ds-space-100, 8px) var(--ds-space-0, 0);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.TzntopStGOcVjM {
  display: block;
  position: relative;
  grid-column: 1 / span 3;
  grid-row: 1;
  height: 40px;
  margin: var(--ds-space-0, 0);
  padding: 0 32px;
  overflow: hidden;
  color: var(--ds-text-subtle, #44546f);
  font-size: 14px;
  font-weight: var(--ds-font-weight-semibold, 600);
  letter-spacing: -0.003em;
  line-height: 40px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.TzntopStGOcVjM.ehJjRqKTyUZYML {
  display: -webkit-box;
  flex: 1;
  height: auto;
  padding: var(--ds-space-0, 0) var(--ds-space-400, 32px);
  overflow: hidden;
  border: 0;
  line-height: initial;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.q2PzD_Dkq1FVX3 {
  -webkit-overflow-scrolling: touch;
  -webkit-transform: translate3d(0, 0, 0);
  padding: 12px;
  overflow-x: hidden;
  overflow-y: auto;
}
.q2PzD_Dkq1FVX3::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.q2PzD_Dkq1FVX3::-webkit-scrollbar-button:start:decrement,
.q2PzD_Dkq1FVX3::-webkit-scrollbar-button:end:increment {
  display: none;
  background: transparent;
}
.q2PzD_Dkq1FVX3::-webkit-scrollbar-track-piece {
  background: var(--ds-background-neutral, #091e420f);
}
.q2PzD_Dkq1FVX3::-webkit-scrollbar-track-piece:vertical:start {
  border-radius: var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px) 0 0;
}
.q2PzD_Dkq1FVX3::-webkit-scrollbar-track-piece:vertical:end {
  border-radius: 0 0 var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px);
}
.q2PzD_Dkq1FVX3::-webkit-scrollbar-track-piece:horizontal:start {
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
}
.q2PzD_Dkq1FVX3::-webkit-scrollbar-track-piece:horizontal:end {
  border-radius: 0 var(--ds-border-radius-100, 4px) var(--ds-border-radius-100, 4px) 0;
}
.q2PzD_Dkq1FVX3::-webkit-scrollbar-thumb:vertical,
.q2PzD_Dkq1FVX3::-webkit-scrollbar-thumb:horizontal {
  display: block;
  height: 48px;
  border-radius: var(--ds-border-radius-100, 4px);
  background: var(--ds-background-neutral-hovered, #091e4224);
}
.q2PzD_Dkq1FVX3:has(.popover-section-animating) {
  overflow-y: hidden;
}
.q2PzD_Dkq1FVX3:focus {
  outline: 0;
}
.q2PzD_Dkq1FVX3.tPiIoMvMEu8lhJ {
  padding-left: var(--ds-space-0, 0);
  padding-right: var(--ds-space-0, 0);
}
.q2PzD_Dkq1FVX3.XwuMWSJIEGKESS {
  padding-bottom: var(--ds-space-0, 0);
}
.q2PzD_Dkq1FVX3.izxI1Gtbkj2jrQ {
  padding-top: var(--ds-space-0, 0);
}
.q7bda2GIwjst4f {
  z-index: 2;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  border: none;
  background: transparent;
  color: var(--ds-icon-subtle, #626f86);
  cursor: pointer;
}
.q7bda2GIwjst4f:hover {
  color: var(--ds-icon, #44546f);
}
.zKzcyhLUVG0jDw {
  grid-column: 3;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--ds-border-radius-200, 8px);
  color: var(--ds-icon-subtle, #626f86);
}
.zKzcyhLUVG0jDw:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-icon, #44546f);
  text-decoration: none;
}
.zKzcyhLUVG0jDw:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  color: var(--ds-icon, #44546f);
  text-decoration: none;
}
.zKzcyhLUVG0jDw.ehJjRqKTyUZYML {
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  width: 40px;
  height: 40px;
}
.zKzcyhLUVG0jDw.Wf3NxQUCrVHW5X {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .zKzcyhLUVG0jDw.Wf3NxQUCrVHW5X {
  outline-color: -webkit-focus-ring-color;
}
.zKzcyhLUVG0jDw.Wf3NxQUCrVHW5X .mac.firefox {
  outline-color: AccentColor;
}
.Uz5Itgv85sjPQ_ {
  grid-column: 1;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--ds-border-radius-200, 8px);
  color: var(--ds-icon-subtle, #626f86);
}
.Uz5Itgv85sjPQ_:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-icon, #44546f);
  text-decoration: none;
}
.Uz5Itgv85sjPQ_:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  color: var(--ds-icon, #44546f);
  text-decoration: none;
}
.Uz5Itgv85sjPQ_.Wf3NxQUCrVHW5X {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .Uz5Itgv85sjPQ_.Wf3NxQUCrVHW5X {
  outline-color: -webkit-focus-ring-color;
}
.Uz5Itgv85sjPQ_.Wf3NxQUCrVHW5X .mac.firefox {
  outline-color: AccentColor;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nch-popover": `rX4pAv5sWHFNjp`,
	"nch-popover__header": `MqQlviJ8LO60NB`,
	"UNSAFE_multilineTitle": `ehJjRqKTyUZYML`,
	"nch-popover__title": `TzntopStGOcVjM`,
	"nch-popover__content": `q2PzD_Dkq1FVX3`,
	"noHorizontalPadding": `tPiIoMvMEu8lhJ`,
	"noBottomPadding": `XwuMWSJIEGKESS`,
	"noTopPadding": `izxI1Gtbkj2jrQ`,
	"nch-popover__iconButton": `q7bda2GIwjst4f`,
	"nch-popover__closeButton": `zKzcyhLUVG0jDw`,
	"hasFocusRing": `Wf3NxQUCrVHW5X`,
	"nch-popover__backButton": `Uz5Itgv85sjPQ_`
};
export default ___CSS_LOADER_EXPORT___;
